import { render, staticRenderFns } from "./AcoesNegociar.vue?vue&type=template&id=643edac9&scoped=true"
import script from "./AcoesNegociar.vue?vue&type=script&lang=js"
export * from "./AcoesNegociar.vue?vue&type=script&lang=js"
import style0 from "./AcoesNegociar.vue?vue&type=style&index=0&id=643edac9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643edac9",
  null
  
)

export default component.exports